{
  "nav": {
    "home": "Accueil",
    "project": "Projet",
    "science": "Science",
    "team": "Équipe",
    "updates": "Actualités",
    "getInvolved": "Rejoindre"
  },
  "footer": {
    "tagline": "Site AquaWorks situé sur le campus de Vancouver de l'Université de la Colombie-Britannique",
    "description": "AquaWorks est un projet d'ingénierie mené par des étudiants, développé par des étudiants de l'Université de la Colombie-Britannique, qui construit un robot de surveillance de la qualité de l'eau assisté par radar.",
    "quickLinks": "Explorer",
    "copyright": "© {{year}} AquaWorks."
  },
  "common": {
    "placeholder": "Contenu à venir.",
    "backToHome": "Retour à l'accueil",
    "source": "Source",
    "planned": "Prévu",
    "notCertification": "Prototype étudiant. Pas une surveillance professionnelle ni une certification de sécurité de l'eau."
  },
  "memberCard": {
    "program": "Faculté",
    "focus": "Focus"
  },
  "languageSwitcher": {
    "chinese": "中文",
    "english": "English",
    "french": "Français",
    "ariaLabel": "Changer de langue"
  },
  "sourceDocuments": {
    "spf": "Demande AMS Sustainability Projects Fund",
    "timeline": "Calendrier AquaWorks Phase 1",
    "ismp": "Plan de gestion intégrée des eaux pluviales (campus de Vancouver)",
    "seeds": "Rapports SEEDS sur les jardins de pluie et les infrastructures vertes"
  }
}
